
webpack.register(
    'components/hole-iframe/hole-iframe',
    function() {
        return require('components/hole-iframe/hole-iframe');
    },
    false
);
webpack.register(
    'components/video-landing/live-video-drawer/featured-slider/featured-slider',
    function() {
        return require('components/video-landing/live-video-drawer/featured-slider/featured-slider');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/hole-iframe/hole-iframe\" />\r\n<can-import from=\"components/video-landing/live-video-drawer/featured-slider/featured-slider\" />\r\n\r\n<div class=\"c-featured-holes\">\r\n    <featured-slider \r\n        {data}=\"swiperData\" \r\n        {current-item}=\"currentHole\" \r\n        (set-current)=\"setCurrent(identifier)\"  \r\n    />\r\n    {{#if currentHole}}\r\n       <div class=\"c-featured-holes__iframe\">\r\n            <hole-iframe {id}=\"currentHole\" {class-name}=\"'s-iframe'\"></hole-iframe>\r\n       </div>\r\n    {{/if}}\r\n</div>");